import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Modal,
  Image,
} from "react-native";
import { formatDistanceToNow } from "date-fns";

import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import Skeletons from "./Skeletons";

const NotificationPopupSkeleton = ({ deviceSize }) => {
  return (
    <View>
      {/* Header: Title and Close Button */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Skeletons height={20} width={"120px"} style={{ borderRadius: 6 }} />
        <Skeletons
          height={
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 20
              : 25
          }
          width={
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? "20px"
              : "25px"
          }
          style={{ borderRadius: 12.5 }}
        />
      </View>
      <Skeletons
        height={1}
        width="100%"
        style={{ marginTop: 10, marginBottom: 10 }}
      />
      {/* Notification Items */}
      {[...Array(3)].map((_, index) => (
        <View key={index}>
          <View style={{ flexDirection: "row" }}>
            <Skeletons
              height={48}
              width={"85px"}
              style={{ borderRadius: 10 }}
            />
            <View style={{ width: "80%", marginLeft: 10 }}>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingBottom: 10,
                }}
              >
                <Skeletons
                  height={16}
                  width={"100px"}
                  style={{ borderRadius: 6 }}
                />
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <Skeletons
                    height={12}
                    width={"80px"}
                    style={{ borderRadius: 6 }}
                  />
                  <Skeletons
                    height={16}
                    width={"16px"}
                    style={{ borderRadius: 8 }}
                  />
                </View>
              </View>
              <Skeletons height={14} width="90%" style={{ borderRadius: 6 }} />
            </View>
          </View>
          <Skeletons
            height={1}
            width="100%"
            style={{ marginTop: 10, marginBottom: 10 }}
          />
        </View>
      ))}
      {/* View All Button */}
      <Skeletons
        height={20}
        width={"80px"}
        style={{ borderRadius: 6, alignSelf: "center" }}
      />
    </View>
  );
};

export default NotificationPopupSkeleton;
